export const theme = {
    COLORS: {
        main: "#F3F2F9",
        TOAST: {
            success: {
                bg: "linear-gradient(0deg, rgba(53, 198, 60, 0.2), rgba(53, 198, 60, 0.2)), rgba(255, 255, 255, 0.9)",
                solid: "#35C63C",
                font: "#35C63C",
            },
            warn: {
                bg: "linear-gradient(0deg, rgba(255, 160, 7, 0.2), rgba(255, 160, 7, 0.2)), rgba(255, 255, 255, 0.9)",
                solid: "#FFA007",
                font: "#FFA007",
            },
            error: {
                bg: "linear-gradient(0deg, rgba(255, 70, 63, 0.2), rgba(255, 70, 63, 0.2)), rgba(255, 255, 255, 0.9)",
                solid: "#FF463F",
                font: "#FF463F",
            },
        },
        CONFIRM: {
            title: {
                font: "#333333",
            },
            content: {
                font: "#666666",
            },
        },
        TABLE: {
            head: "#F3F2F9",
            border: "#DEDCEC",
            font: {
                head: "#1B0751",
                body: "#38304D",
            }
        },
        MODAL: {
            head: {
                font: "#23203B",
            }
        },
        PAGINATION: {
            active: {
                font: "#4939B1",
                bg: "#F3F2F9",
                weight: 700
            },
            inActive: {
                font: "#999999",
                bg: "#fff"
            }
        },
        HEADER: {
            active: {
                primary: "#23203B",
            },
            border: "#E6E6E6",
            log: "#666666",
            default: "#999999"
        },
        SIDE_NAV: {
            primary: "#212121",
            active: {
                primary: {
                    background: "rgba(66, 66, 66, 0.8)",
                    line: "#4939B1"
                },
                list: {
                    primary: {
                        background: "#616161",
                    }
                }
            },
            font: {
                primary: "#fff",
            }
        },
        INPUT: {
            brand: {
                text: {
                    active: "#4939B1",
                    inActive: "#4939B1",
                },
            },
            text: {
                active: "#564F67",
                inActive: "#D1D1D1",
                disabled: {
                    solid: "#D1D1D1",
                    bg: "#F2F2F2",
                },
                font: {
                    default: "#333333",
                    disabled: "#CCCCCC",
                },
                placeholder: "#999999",
            },
            password: {
                active: "#564F67",
                inActive: "#D1D1D1",
                disabled: {
                    solid: "#D1D1D1",
                    bg: "#F2F2F2",
                },
                font: {
                    default: "#333333",
                    disabled: "#CCCCCC",
                },
                placeholder: "#999999",
            },
            box: {
                active: "#4939B1",
                inActive: "#CCCCCC",
                disabled: {
                    solid: "#E6E6E6",
                    bg: "#F2F2F2"
                },
                font: {
                    default: "#38304D",
                    disabled: "#CCCCCC",
                }
            },
        },
        BUTTON: {
            black: {
                default: {
                    bg: {
                        primary: "#23203B",
                        sub: "#EBE9F4",
                        hover: "#1B0751",
                        disabled: "#E6E6E6",
                    },
                    line: {}
                },
                solid: {
                    bg: {
                        primary: "#fff",
                        sub: "#",
                        hover: "#EBE9F4",
                        disabled: "#fff",
                    },
                    line: {
                        primary: "#23203B",
                        sub: "#",
                        hover: "#EBE9F4",
                        disabled: "#CCCCCC",
                    }
                },
            },
            brand: {
                default: {
                    bg: {
                        primary: "#4939B1",
                        sub: "#F3F2F9",
                        hover: "#7566D0",
                        disabled: "#BFB4F7",
                    },
                    line: {}
                },
                solid: {
                    bg: {
                        primary: "#fff",
                        sub: "#",
                        hover: "#F3F2F9",
                        disabled: "#fff",
                    },
                    line: {
                        primary: "#4939B1",
                        sub: "#",
                        hover: "#F3F2F9",
                        disabled: "#DFD9FB",
                    }
                },
            },
            font: {
                black: {
                    default: {
                        primary: "#fff",
                        sub: "#",
                        hover: "#fff",
                        disabled: "#999999",
                    },
                    solid: {
                        primary: "#564F67",
                        sub: "#",
                        hover: "#23203B",
                        disabled: "#CCCCCC",

                    },
                },
                brand: {
                    default: {
                        primary: "#fff",
                        sub: "#",
                        hover: "#fff",
                        disabled: "#DFD9FB",
                    },
                    solid: {
                        primary: "#4939B1",
                        sub: "#",
                        hover: "#4939B1",
                        disabled: "#BFB4F7",

                    },
                },

            },
        },
    },
    SIZE: {
        INPUT: {
            text: {
                width: "100%",
                height: "44px",
                font: "14px",
                weight: "400",
            },
            tel: {
                width: "100%",
                height: "44px",
                font: "14px",
                weight: "400",
            },
            password: {
                width: "100%",
                height: "44px",
                font: "14px",
                weight: "400",
            },
            checkbox: {
                width: "20px",
                height: "20px",
                font: "14px",
                weight: "400",
            },
            radio: {
                width: "20px",
                height: "20px",
            },
        },
        BUTTON: {
            width: {
                // s: "69px",
                // m: "77px",
                // l: "92px",
                // xl: "103px",
                // xxl: "106px",
                full: "100%",
                padding: {
                    s: "0 12px",
                    m: "0 16px",
                    l: "0 20px",
                    xl: "0 24px",
                }
            },
            arrow: {
                width: {
                    s: "28px",
                    m: "36px",
                    l: "44px",
                    xl: "56px",
                },
                height: {
                    s: "28px",
                    m: "36px",
                    l: "44px",
                    xl: "56px",
                },
            },
            height: {
                s: "28px",
                m: "36px",
                l: "44px",
                xl: "56px",
            },
            font: {
                s: "14px",
                m: "14px",
                l: "16px",
                xl: "14px",
                xxl: "18px",
            },
            weight: {
                s: "600",
                m: "600",
                l: "600",
                xl: "600",
            },
            round: {
                s: "4px",
                m: "4px",
                l: "8px",
                xl: "8px",
            },
            capsule: {
                s: "99px",
                m: "99px",
                l: "99px",
                xl: "99px",
            }
        },
        FONT: {
            xxs: "10px",
            xs: "12px",
            s: "14px",
            m: "16px",
            ml: "18px",
            l: "20px",
            xl: "24px",
            xxl: "32px",
        },
        TABLE: {
            THEAD: {
                height: "44px",
                font: "12px",
                weight: "700"
            },
            TBODY: {
                height: "72px",
                font: "14px",
                weight: "400"
            },
        },
        PAGINATION: {
            width: "40px",
            height: "40px",
            font: "14px",
            weight: "500",
            gap: "10px",
            active: {
                weight: "700"
            }
        },
        MODAL: {
            padding: "20",
            head: {
                height: "56px",
                font: "32px",
                weight: "700",
                close: {
                    width: "24px",
                    height: "24px",
                },
            }
        },
        CONFIRM: {
            width: "480px",
            height: "248px",
            title: {
                font: "20px",
                weight: "600",
            },
            content: {
                font: "18px",
                line_height: "24px",
                weight: "400",
            },
        },
        TOAST: {
            font: "18px",
            weight: "500",
            line_height: "24px",
            width: "345px",
            height: "52px",
            maxWidth: "680px",
        },
        SIDE_NAVI: "280px",
        HEADER: {
            pc: "96px",
            mo: "64px"
        }
    },

};
export default theme;
